import * as React from 'react';
import clx from 'classnames';
import { Col, Typography, Card, Alert, Space, Row, Tooltip } from 'antd';
const { Title } = Typography;
import { SpaceProps } from 'antd/lib/space';

export interface StepTitleTooltipProps {
  title: string;
}

/**
 * Sezione per visualizzare i pulsanti di invio domanda
 * alla fine del form (solo desktop)
 */
export function StepTitleTooltip(props: StepTitleTooltipProps) {
  return <Tooltip title={props.title}>{props.title}</Tooltip>;
}
